import React from "react";
import Header from "../components/Header";
import Podcast from "../components/Podcast";
import CoreValues from "../components/CoreValues";
import Salvation from "../components/Salvation";
import Mission from "../components/Mission";
import News from "../components/News";
import Footer from "../components/Footer";

export default function Members() {
  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);

    const data = {
      firstName: (formData.get("firstName") || "").toString().trim(),
      lastName: (formData.get("lastName") || "").toString().trim(),
      email: (formData.get("email") || "").toString().trim(),
      phone: (formData.get("phone") || "").toString().trim(),
      acceptTerms: formData.get("acceptTerms") ? "yes" : "no",
    };

    if (!data.firstName || !data.lastName || !data.email) {
      alert("Please fill in your first name, last name, and email.");
      return;
    }

    try {
      const res = await fetch("/api/memberMail.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: new URLSearchParams(data).toString(),
      });

      const text = await res.text();

      let json;
      try {
        json = JSON.parse(text);
      } catch {
        throw new Error("Server returned an unexpected response (not JSON).");
      }

      if (!res.ok || !json?.success) {
        throw new Error(json?.error || "Unable to send your request.");
      }

      alert("Membership request sent. Thank you for connecting with us!");
      form.reset();
    } catch (err) {
      console.error(err);
      alert(`Error: ${err?.message || "Something went wrong. Please try again later."}`);
    }
  };

  return (
    <div>
      <Header />
      <hr className="g-brd-gray-light-v4 my-0" />

      <section className="container g-py-75">
        <div className="row justify-content-center">
          <div className="col-sm-8 col-md-8 col-lg-6">
            <div className="g-brd-around g-brd-gray-light-v4 rounded g-py-30 g-px-30--lg g-px-30--md g-px-15--sm g-px-15">
              <header className="text-center g-pb-0">
                <h2 className="h2 g-color-black g-font-weight-600">Become a Member</h2>
                <p className="g-color-gray-dark-v5 g-font-size-13 g-mt-10">
                  Share your information below and let us know you&apos;d like to connect with
                  Bishop K.J. Brown Ministries. Someone from our team will follow up with you.
                </p>
              </header>

              <form className="g-py-15" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-xs-12 col-sm-6 g-mb-20 g-px-10">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text g-width-45 g-brd-right-none g-brd-gray-light-v4 g-color-gray-dark-v5">
                          <i className="icon-finance-067 u-line-icon-pro" />
                        </span>
                      </div>
                      <input
                        className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover g-py-15 g-px-15"
                        type="text"
                        name="firstName"
                        placeholder="First name"
                        required
                      />
                    </div>
                  </div>

                  <div className="col-xs-12 col-sm-6 g-mb-20 g-px-10">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text g-width-45 g-brd-right-none g-brd-gray-light-v4 g-color-gray-dark-v5">
                          <i className="icon-finance-067 u-line-icon-pro" />
                        </span>
                      </div>
                      <input
                        className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover g-py-15 g-px-15"
                        type="text"
                        name="lastName"
                        placeholder="Last name"
                        required
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 g-mb-20 g-px-10">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text g-width-45 g-brd-right-none g-brd-gray-light-v4 g-color-gray-dark-v5">
                          <i className="icon-communication-062 u-line-icon-pro" />
                        </span>
                      </div>
                      <input
                        className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover g-py-15 g-px-15"
                        type="email"
                        name="email"
                        placeholder="E-mail"
                        required
                      />
                    </div>
                  </div>

                  <div className="col-12 g-mb-20 g-px-10">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text g-width-45 g-brd-right-none g-brd-gray-light-v4 g-color-gray-dark-v5">
                          <i className="icon-communication-062 u-line-icon-pro" />
                        </span>
                      </div>
                      <input
                        className="form-control g-color-black g-bg-white g-bg-white--focus g-brd-gray-light-v4 g-brd-primary--hover g-py-15 g-px-15"
                        type="tel"
                        name="phone"
                        placeholder="Telephone (optional)"
                      />
                    </div>
                  </div>
                </div>

                {/* ✅ Checkbox: make it normal + clickable */}
                <div className="row justify-content-center">
                  <div className="col-md-9 align-self-center g-px-10">
                    <label className="g-color-gray-dark-v5 g-font-size-13 mb-0" style={{ display: "flex", gap: 10 }}>
                      <input type="checkbox" name="acceptTerms" required />
                      <span>
                        I accept the{" "}
                        <a href="/policy" target="_blank" rel="noreferrer">
                          Terms and Conditions
                        </a>
                      </span>
                    </label>
                  </div>

                  <div className="col-md-3 align-self-center g-px-10 text-right">
                    <button className="btn btn-md u-btn-primary rounded g-py-10" type="submit">
                      Membership
                    </button>
                  </div>
                </div>
              </form>

              <footer className="text-center">
                <p className="g-color-gray-dark-v5 g-font-size-13 mb-0">
                  Already a member? Stay connected through our services, Bible studies, and events.
                </p>
              </footer>
            </div>
          </div>
        </div>
      </section>

      <Podcast />
      <CoreValues />
      <Salvation />
      <Mission />
      <News />
      <Footer />
    </div>
  );
}